import React from 'react';

import TableColumnVisibility, { TableColumnVisibilityProps } from './TableColumnVisibility';

type Props = TableColumnVisibilityProps;

export default function TableSettingsManager({ settings, lockedColumns = [0] }: Props) {
    return (
        <span className="mr-3">
            <div className="form-group d-inline-block">
                <div className="dropdown">
                    <button
                        className="btn btn-white border dropdown-toggle"
                        type="button"
                        id="column-visibility-button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        Columns
                    </button>
                    <div
                        className="dropdown-menu shadow px-1 py-0 pt-1"
                        aria-labelledby="column-visibility-button"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <TableColumnVisibility settings={settings} lockedColumns={lockedColumns} />
                    </div>
                </div>
            </div>
            {/* placeholder for future component to select the number of rows per page for pagination */}
        </span>
    );
}
